// src/components/CustomNavbar.jsx
import React, { useState } from "react";
import { AppBar, Toolbar, Typography, Box, Menu, MenuItem, IconButton, Grid, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { GrPowerShutdown } from "react-icons/gr";
import favicon_etiqueta from "../assets/favicon_etiqueta.png";
import localforage from "localforage";

export default function CustomNavbar({ user }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = async () => {
    await localforage.clear();
    window.location.href = "/login";
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#dddddd",
        borderRadius: 2,
        m: 1,
      }}
    >
      <Toolbar sx={{ color: "black"}}>
        {/* Logo */}
        <Box component="a" href="/" sx={{ mr: 2 }}>
          <Box
            component="img"
            src={favicon_etiqueta}
            sx={{ width: 50, height: 50 }}
          />
        </Box>

        {/* Dropdown */}
        <Box>
          <Button
            color="inherit"
            startIcon={<MenuIcon />}
            onClick={handleMenuOpen}
          >
            Molde etiqueta
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleMenuClose} component="a" href="/cadastrareditarmolde">
              Cadastrar molde
            </MenuItem>
            <MenuItem onClick={handleMenuClose} component="a" href="/buscarmoldes">
              Buscar molde
            </MenuItem>
          </Menu>
        </Box>

        {/* Link simples */}
        <Button color="inherit" href="/printetiquetas">
          Imprimir etiquetas
        </Button>

        {/* Espaço flexível */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Info do usuário */}
        <Box sx={{ mr: 2, textAlign: "right" }}>
          <Typography variant="caption" display="block">
            {(user?.nomeOrganizacao ?? "") + " - " + user?.idOrganizacao}
          </Typography>
          <Typography variant="caption" display="block">
            {user?.nomeFuncionario}
          </Typography>
          <Typography variant="caption" display="block">
            {user?.login}
          </Typography>
        </Box>

        {/* Botão sair */}
        <IconButton onClick={handleLogout}>
          <GrPowerShutdown color="red" size={20} title="Sair" />
        </IconButton>
        <Typography variant="body2" color="red">
          Sair
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
